import { ReactElement } from 'react';
import clsx from 'clsx';
import Button from '../../controls/Button';
import { ExtendedDeviceAttributes } from '../../constants/telosair-interfaces';

type DeviceItemProps = {
  isNotSelected: boolean;
  device: ExtendedDeviceAttributes;
  handleSelect: (deviceId: number, selected: boolean) => void;
  keepBordersalways?: boolean;
};

/**
 * Component for displaying Device with minimal details and a CTA to select.
 * @param props - Device Item Properties.
 * @returns A React element representing the Device Item component.
 */
function DeviceSelect(props: DeviceItemProps): ReactElement {
  const { device, handleSelect, isNotSelected, keepBordersalways = false } = props;
  return (
    <div
      key={device.id}
      className={clsx(
        'h-16 basis-0 self-stretch p-3 justify-between items-center flex rounded-lg border',
        {
          'dark:border-gray-50 mt-2': !isNotSelected
        },
        {
          'dark:border-gray-700 mt-2': isNotSelected
        },
        {
          'border-none': isNotSelected && !keepBordersalways
        }
      )}
    >
      <div className="justify-center items-center gap-2 flex">
        <div className="h-6 w-6 rounded-full bg-primary-500" />
        <div>
          <div className="text-gray-300 text-sm font-medium">{device.deviceName}</div>
          <div className="justify-start items-center inline-flex text-gray-500 text-xs font-normal">
            ID: {device.serialNumber}
            {/* {device.serial_number} | {device.facility} */}
          </div>
        </div>
      </div>
      <Button
        theme={isNotSelected ? 'secondary-color' : 'primary'}
        size="xs"
        name={isNotSelected ? 'Select' : 'Selected'}
        onClick={() => {
          handleSelect(device.id, isNotSelected);
        }}
      />
    </div>
  );
}

export default DeviceSelect;
